import { isElement } from "@knyt/artisan";
import { isKnytDeclaration } from "./KnytDeclaration.js";
export function isKnytNode(value) {
    return isElement(value) || isKnytDeclaration(value);
}
